import { render, staticRenderFns } from "./headMenu2.vue?vue&type=template&id=40a101fc&scoped=true"
import script from "./headMenu2.vue?vue&type=script&lang=js"
export * from "./headMenu2.vue?vue&type=script&lang=js"
import style0 from "./headMenu2.vue?vue&type=style&index=0&id=40a101fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a101fc",
  null
  
)

export default component.exports